import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const ThoughtCloudHeader = () => {
    return(
        <>
            <header>
                <div className="grid-page-wrap">
                   <Link to="/thoughtcloud/home"> <img src="/images/thought-cloud.png"  width="250" height="33" /></Link>
                </div>
            </header>
        </>
    )
}
export default ThoughtCloudHeader;